var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('VueMarkdown',{staticClass:"mt-1 max-w-2xl text-sm leading-5 prose max-w-none",attrs:{"source":this.introduction}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }